import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { getAlterationTestimonials } from '../../../mocks/pretAPorter';

export default function AlterationTestimonials() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [current, setCurrent] = useState(0);

  const testimonials = getAlterationTestimonials();
  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="max-w-4xl mx-auto" style={style}>
          <div className="text-center mb-12">
            <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
              Opiniones
            </span>
            <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
              Clientes satisfechos
            </h2>
          </div>

          <div className="bg-brand-gray-50 rounded-[32px] p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Stars */}
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-brand-sage flex items-center justify-center">
                  <i className="ri-user-smile-line text-brand-black text-2xl" />
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-brand-black text-sm" />
                  ))}
                </div>
                <p className="font-serif text-brand-gray-600 text-lg leading-[1.7] italic">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="mt-5">
                  <span className="font-sans text-brand-black text-sm font-bold">
                    {t.name}
                  </span>
                  <span className="font-sans text-brand-gray-400 text-sm ml-2">
                    — {t.location}
                  </span>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="mt-8 flex justify-center gap-4">
              <button
                onClick={prev}
                className="w-12 h-12 rounded-full border border-brand-gray-200 flex items-center justify-center text-brand-gray-400 hover:border-brand-gray-400 hover:text-brand-black transition-all duration-300"
                aria-label="Anterior"
              >
                <i className="ri-arrow-left-line" />
              </button>
              <button
                onClick={next}
                className="w-12 h-12 rounded-full bg-brand-black flex items-center justify-center text-white hover:bg-brand-gray-600 transition-all duration-300"
                aria-label="Siguiente"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}